<template>
  <div class="container">
    <div class="row dashBoardOrdersWrapper">
       <div class="col-md-4">
        <h2><span class="fontIcon"><font-awesome-icon :icon="['fal', 'file-alt']"></font-awesome-icon></span> {{ msg }}</h2>
      </div>
      <div class="content-section implementation dataview-demo">
        <DataTable class="orderlist" :value="orders" :autoLayout="true" data-key="id" paginatorPosition="both" selectionMode="single" :selection.sync="selectedOrder" @row-select="orderDetails(selectedOrder, ordersSchema)" :paginator="true" :rows="20" :sortOrder="sortOrder" :sortField="sortField">
            <template #header>
            <div style="text-align: left">
              <i class="pi pi-search" style="margin: 4px 4px 0px 0px;"></i>
              <InputText v-model="filters['global']" placeholder="Sökfilter" size="50" />
            </div>
          </template>
           <Column field="state" header="Status" filterMatchMode="in" :sortable="true">
               <template #body="slotProps">
                 <div :class="[slotProps.data.state]">
                    <span>{{slotProps.data.state}}</span>
                  </div>
              </template>
              <template #filter>
                <MultiSelect v-model="filters['state']" :options="filterOptions" optionLabel="label" optionValue="value" placeholder="Filtrera.." />
              </template>
            </Column>
            <Column field="data.data_dateBooking" header="Lastdatum" :sortable="true">
              <template #body="slotProps" >
                {{formatDate(slotProps.data.data.dateBooking)}}
              </template>
            </Column>
            <Column field="data.data_dateDelivery" header="Lossdatum" :sortable="true">
              <template #body="slotProps" >
                {{formatDate(slotProps.data.data.dateDelivery)}}
              </template>
            </Column>
            <Column field="data.data_fraktsedelNr" header="Fraktsedelnr" :sortable="true">
                <template #body="slotProps" >
                  {{slotProps.data.data.fraktsedelNr}}
                </template>
            </Column>
            <Column field="data.data_productId" header="ProduktId" :sortable="true">
                <template #body="slotProps" >
                  {{slotProps.data.data.productId}}
                </template>
            </Column>
            <Column field="data.data_GroupLoading" header="Samlast" :sortable="true">
                <template #body="slotProps" >
                  {{slotProps.data.data.GroupLoading}}
                </template>
            </Column>
            <Column field="data.data_driverLoading" header="Chaufför" :sortable="true">
                <template #body="slotProps" >
                  {{getDriverName(slotProps.data.data.driverLoading)}}
                </template>
            </Column>
            <Column field="data.data_truck" header="Lastbil" :sortable="true">
                <template #body="slotProps" >
                  {{getTruckName(slotProps.data.data.truck)}}
                </template>
            </Column>
            <Column field="data.data_trailer" header="Släp" :sortable="true">
                <template #body="slotProps" >
                  {{getTrailerName(slotProps.data.data.trailer)}}
                </template>
            </Column>
            <Column field="data.data_quantity" header="Kvantitet" :sortable="true">
                <template #body="slotProps" >
                  <span v-if="slotProps.data.data.orderRows">{{checkLoadedQuantity(slotProps.data.data.orderRows[0])}}</span>
                  <span v-else>{{slotProps.data.data.quantity}}</span>
                </template>
            </Column>
            <Column headerStyle="width: 8em" bodyStyle="text-align: center">
                <template #body="slotProps">
                  <Button icon="pi pi-ban" @click="archiveOrder(slotProps.data.id)" />
                </template>
            </Column>
        </DataTable>
    </div>
    </div>
    <div class="row">
      <div class="col-md-12">
         <router-link class="btn btn-primary" :to="{ name: 'FeralcoInternOrderCreate', params: {type: 'feralcoIntern', schema: ordersSchema}}">
               Skapa ny
          </router-link>
      </div>
    </div>
  </div>
</template>
<script>
import 'primeflex/primeflex.css'
import DataViewPrime from 'primevue/dataview'
import Dropdown from 'primevue/dropdown'
import Button from 'primevue/button'
import DataTable from 'primevue/datatable'
import InputText from 'primevue/inputtext'
import Column from 'primevue/column'
import MultiSelect from 'primevue/multiselect'
export default {
  name: 'FeralcoInternOrdersList',
  components: {
    'DataView': DataViewPrime,
    'Dropdown': Dropdown,
    Button,
    DataTable,
    Column,
    MultiSelect,
    InputText
  },
  data () {
    return {
      msg: 'Feralco internordrar',
      activeBtn: 'all',
      orders: [],
      orderTypes: [],
      ordersSchema: {},
      endCustomerName: '',
      drivers: [],
      trucks: [],
      trailers: [],
      layout: 'list',
      selectedOrder: null,
      sortKey: null,
      sortOrder: null,
      sortField: null,
      filters: {},
      selectedFilter: null,
      filterOptions: [
        {label: 'Redo', value: 'redo'},
        {label: 'Skickade', value: 'skickad'},
        {label: 'Accepterade', value: 'accepterad'},
        {label: 'Sparade', value: 'sparad'},
        {label: 'Avslutade', value: 'avslutad'}
      ]
    }
  },
  props: {
    id: ''
  },
  async mounted () {
    var response = await this.getOrders()
    this.orders = response.orders.filter((el) => el.state !== 'makulerad')
    this.ordersSchema = response.schema
    this.orderTypes = await this.getOrderTypes()
    this.drivers = await this.getDrivers()
    this.trucks = await this.getTrucks()
    this.trailers = await this.getTrailers()
  },
  methods: {
    checkLoadedQuantity (orderRow) {
      let loadedObjs = orderRow.actions.filter((el) => el.name === 'Lastar')
      let loadedQuantity = 0
      loadedObjs.forEach((obj) => {
        loadedQuantity = loadedQuantity + parseInt(obj.amount)
      })
      return loadedQuantity
    },
    flattenObj (obj, parent, res = {}) {
      for (let key in obj) {
        let propName = parent ? parent + '_' + key : key
        if (typeof obj[key] === 'object') {
          this.flattenObj(obj[key], propName, res)
        } else {
          res[propName] = obj[key]
        }
      }
      return res
    },
    async filterOrders (btnState) {
      this.activeBtn = btnState
      var response = await this.getOrders()
      if (btnState !== 'all') {
        this.orders = response.orders.filter((el) => el.state === btnState)
      } else {
        this.orders = response.orders.filter((el) => el.state !== 'makulerad')
      }
    },
    formatDate (theDate) {
      let withYear = new Date(theDate)
      withYear = withYear.getFullYear() + '-' + ('0' + (withYear.getMonth() + 1)).slice(-2) + '-' + ('0' + (withYear.getDate())).slice(-2)
      return withYear
    },
    orderDetails (order, ordersSchema) {
      this.$router.push({ name: 'FeralcoInternOrderDetails', params: { id: order.id, order: order, schema: ordersSchema } })
    },
    async getOrders () {
      let response = await this.$http.get('/api/orders/by-type/' + this.$props.id)
      return response.data
    },
    async getOrderTypes () {
      let response = await this.$http.get('/api/orders/types')
      return response.data
    },
    async getDrivers () {
      let response = await this.$http.get('/api/users/drivers')
      return response.data
    },
    async getTrucks () {
      let response = await this.$http.get('api/objectdatas/objectdescriptionid/5')
      return response.data
    },
    async getTrailers () {
      let response = await this.$http.get('/api/objectdatas/objectdescriptionid/8')
      return response.data
    },
    getDriverName (driverId) {
      if (driverId !== undefined) {
        var drivers = this.drivers
        if (drivers.length > 0) {
          var driver = drivers.find(driver => {
            return driver.id === driverId
          })
          return driver.userName
        }
      } else {
        return ''
      }
    },
    getTruckName (truckId) {
      if (truckId !== undefined) {
        var trucks = this.trucks
        if (trucks.length > 0) {
          var truck = trucks.find(truck => {
            return truck.id === truckId
          })
          return truck.data.regnbr
        }
      }
    },
    getTrailerName (trailerId) {
      if (trailerId !== undefined) {
        var trailers = this.trailers
        if (trailers.length > 0) {
          var trailer = trailers.find(trailer => {
            return trailer.id === trailerId
          })
          return trailer.data.regnbr
        }
      }
    },
    onSortChange (event) {
      this.sortField = event
      if (this.sortKey === event) {
        this.sortKey = null
        this.sortOrder = -1
      } else {
        this.sortKey = event
        this.sortOrder = 1
      }
    },
    archiveOrder (id) {
      let message = 'Vill du arkivera ordern?'
      let options = {
        okText: 'Fortsätt',
        cancelText: 'Stäng'
      }
      this.$dialog.confirm(message, options)
        .then(dialog => {
          this.$http
            .put('/api/orders/' + id + '/changestate/arkiverad')
            .then(response => {
              this.$toast.add({severity: 'success', summary: 'Order arkiverad', life: 3000})
              const i = this.orders.map(item => item.id).indexOf(id)
              this.orders.splice(i, 1)
            })
            .catch(error => console.log(error))
        })
        .catch(function () {
          console.log('Clicked on cancel')
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Orders/FeralcoInternOrdersList.vue